import apiClient from './client'
import type { ReviewQueue } from './review-types'

export interface NamedCollection {
  id: string
  matter_id: string
  name: string
  description?: string | null
  metadata?: Record<string, unknown> | null
  source_type: string
  source_run_id?: string | null
  subset_run_id?: string | null
  source_query?: string | null
  document_count: number
  created_at: string
  updated_at: string
}

export interface CreateNamedCollectionPayload {
  name: string
  document_ids: string[]
  source_run_id: string
  description?: string
  metadata?: Record<string, unknown>
}

export type CodingBucketCollectionSource =
  | {
      kind: 'documents'
      bucket:
        | 'privilege_flagged'
        | 'privilege_confirmed'
        | 'tag_hot'
        | 'tag_critical'
        | 'tag_watch'
        | 'needs_review_required'
        | 'needs_review_unscored'
    }
  | {
      kind: 'ask_evidence'
      ask_id: string
      relation: 'responsive'
    }

export interface CreateCodingBucketCollectionPayload {
  name?: string
  description?: string
  source: CodingBucketCollectionSource
  create_review_queue?: boolean
}

export interface CodingBucketCollectionResult {
  collection: NamedCollection
  review_queue: ReviewQueue | null
}

export const namedCollectionsApi = {
  async list(matterId: string): Promise<NamedCollection[]> {
    const { data } = await apiClient.get<NamedCollection[]>(
      `/matters/${matterId}/named-collections`
    )
    return data
  },

  async create(
    matterId: string,
    payload: CreateNamedCollectionPayload
  ): Promise<NamedCollection> {
    const { data } = await apiClient.post<NamedCollection>(
      `/matters/${matterId}/named-collections`,
      payload
    )
    return data
  },

  async createReviewQueue(
    matterId: string,
    collectionId: string
  ): Promise<ReviewQueue> {
    const { data } = await apiClient.post<ReviewQueue>(
      `/matters/${matterId}/named-collections/${collectionId}/review-queue`
    )
    return data
  },

  async createFromCodingBucket(
    matterId: string,
    payload: CreateCodingBucketCollectionPayload
  ): Promise<CodingBucketCollectionResult> {
    const { data } = await apiClient.post<CodingBucketCollectionResult>(
      `/matters/${matterId}/named-collections/from-coding-bucket`,
      payload
    )
    return data
  },
}
